import { render, staticRenderFns } from "./AddEditReal.vue?vue&type=template&id=66998c72&scoped=true&"
import script from "./AddEditReal.vue?vue&type=script&lang=js&"
export * from "./AddEditReal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditReal.vue?vue&type=style&index=0&id=66998c72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66998c72",
  null
  
)

export default component.exports